import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ComponentStatus } from 'bom/enums';
import { Button } from 'core/components';
import { useAgGridTableContext } from 'core/states';
import { IJobPart } from 'jobs/types';
import { Color, Variant } from 'theme/enums';

import { AddToJob } from './AddToJob';

export const AddToJobButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  const { selectedRows } = useAgGridTableContext();

  const selectedActiveJobParts = useMemo(() => {
    return selectedRows.filter(
      (jobPart: IJobPart) => jobPart.status !== ComponentStatus.DELETED
    ) as IJobPart[];
  }, [selectedRows]);

  const isDisabled = useMemo(
    () =>
      selectedActiveJobParts.length === 0 ||
      selectedRows.every((jobPart: IJobPart) => jobPart.status === ComponentStatus.DELETED),
    [selectedActiveJobParts, selectedRows]
  );

  return (
    <>
      <Button
        text={t('buttonLabelAddToJob')}
        variant={Variant.OUTLINED}
        color={Color.NEUTRAL}
        onClick={() => setIsOpen(true)}
        disabled={isDisabled}
      />

      {!isDisabled && (
        <AddToJob
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          jobParts={selectedActiveJobParts}
        />
      )}
    </>
  );
};
